<template>
  <section
    class="n-section-primary tw-flex tw-flex-col tw-overflow-hidden"
    :style="`background-color: var(--c-${vars.backgroundColor});color: ${vars.textColor ? `var(--c-${vars.textColor})` : 'var(--c-text-primary)'}`"
  >
    <BlockSymbol
      v-if="vars.watermarkImage"
      :block-logo-image="String(vars.watermarkImage)"
      :block-opacity="Number(vars?.watermarkOpacityNumber || 1)"
      position-text="left_top"
      :company-key="company.company_key"
    />
    <div class="tw-flex tw-w-full tw-flex-col tw-items-start tw-gap-3 lg:tw-items-center">
      <h6 :style="`color: var(--c-${vars.textColor})`">{{ vars.altTitleText }}</h6>
      <h2 :style="`color: var(--c-${vars.textColor})`">{{ vars.titleText }}</h2>
    </div>

    <div
      v-for="(section, index) in sections"
      :key="index"
      class="tw-mt-12 tw-flex tw-w-full tw-max-w-[610px] tw-flex-col-reverse tw-items-center tw-gap-y-8 lg:tw-mt-16 lg:tw-max-w-none lg:tw-gap-x-32 xl:tw-gap-x-40"
      :class="{ 'lg:tw-flex-row-reverse': index % 2 === 0, 'lg:tw-flex-row': index % 2 === 1 }"
    >
      <div class="tw-flex tw-flex-col tw-items-start tw-gap-4 lg:tw-basis-[70%] xl:tw-basis-[90%]">
        <h3 :style="`color: var(--c-${vars.textColor})`">{{ section.title }}</h3>
        <div class="tw-mt-5 tw-flex tw-flex-col tw-gap-y-4">
          <p :style="`color: var(--c-${vars.textColor})`">
            {{ section.description }}
          </p>
        </div>
        <nuxt-link :to="section.button_link" :class="`n-${section.button_type} n-btn tw-w-full md:tw-w-auto`"
          ><div class="n-btn-container tw-w-full md:tw-w-auto">
            <div class="n-btn-group">
              <div class="n-btn-t1">{{ section.button_label }}</div>
              <div class="n-btn-t2">{{ section.button_label }}</div>
            </div>
          </div></nuxt-link
        >
      </div>

      <div class="tw-w-full">
        <iframe
          v-if="section.video"
          class="tw-w-full tw-rounded-xl tw-object-cover"
          :src="String(section.video)"
          style="border-radius: var(--rounded)"
          frameborder="0"
          allowfullscreen
          :style="vars.isVerticalBool ? 'aspect-ratio:5/8;' : 'aspect-ratio: 16/9;'"
        ></iframe>

        <LibraryImage
          v-if="section.photo && !section.video"
          :src="String(section.photo)"
          :w-ratio="vars.isVerticalBool ? 9 : 645"
          :h-ratio="vars.isVerticalBool ? 16 : 430"
          style="border-radius: var(--rounded)"
        />
      </div>
    </div>
  </section>
</template>

<script lang="ts">
import { ComponentMixin } from '~/mixins/component.mixin';
import BlockSymbol from '~/components/common/BlockSymbol.vue';
export default defineNuxtComponent({
  components: { BlockSymbol },
  mixins: [ComponentMixin],

  data() {
    return {
      isVisible: false,
    };
  },

  computed: {
    sections() {
      return this.groupedVariables.sections;
    },
  },

  methods: {
    isExternalLink(url: string) {
      return url.includes('http');
    },
  },
});
</script>
